import React, { useState, useEffect, useRef } from 'react';

export default (WrappedComponent) => {
  const handles = [];

  const Track = (props) => {
    const [isWithinTrac, setIsWithinTrac] = useState();
    const [isTrackBottom, setIsTrackBottom] = useState();

    const nodeRef = useRef();

    const getBoundingClientRect = (node) => node.getBoundingClientRect();

    const getParentNode = () => nodeRef && nodeRef.current?.parentNode;

    const getFirstChild = () => nodeRef.current?.firstChild;

    const isComponentWithinTrack = () => {
      if (!getParentNode()) return;

      const parentRect = getBoundingClientRect(getParentNode());
      const comp = getBoundingClientRect(getFirstChild());
      const trackBottom =
        window.pageYOffset + parentRect.top + parentRect.height - comp.height;

      if (parentRect.top < 1 && window.pageYOffset < trackBottom) {
        if (!isWithinTrac) {
          setIsWithinTrac(true);
          setIsTrackBottom(false);
        }
      } else {
        if (isWithinTrac) {
          setIsWithinTrac(false);
          setIsTrackBottom(window.pageYOffset >= trackBottom);
        }
      }
    };

    useEffect(() => {
      handles.push(isComponentWithinTrack);
      requestAnimationFrame(() => {
        isComponentWithinTrack();
      });
    }, [isTrackBottom]);

    return (
      <div ref={nodeRef}>
        <WrappedComponent
          {...props}
          isWithinTrac={isWithinTrac}
          isTrackBottom={isTrackBottom}
        />
      </div>
    );
  };

  let ticking = false;
  const throttleScroll = () => {
    ticking =
      ticking ||
      requestAnimationFrame(() => {
        ticking = false;
        handles.map((handle) => handle());
      });
  };

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', throttleScroll, false);
    window.addEventListener('resize', throttleScroll, false);
  }

  return Track;
};
